<template>
  <Navigation />
  <div class="uk-section uk-section-small">
    <div class="uk-container uk-container-expand">
      <div class="uk-card">
        <h1>Reportes</h1>
        <div uk-grid>
          <div class="uk-width-1-4@m">
            <div uk-sticky>
              <TotalHours :TotalHours="totalHoursWorks"/>
              <div class="header">
              <div
                class="uk-card uk-card-default uk-card-body uk-border-rounded"
              >
              
                <div uk-grid>
                  <div class="uk-width-1-1">
                    <div class="uk-inline uk-width-1-1">
                      <input
                        class="uk-input uk-width-1-1"
                        type="search"
                        v-model="searchQuery"
                        placeholder="Buscar..."
                        name="q"
                      />
                      <a class="uk-form-icon uk-form-icon-flip" uk-icon="icon: close" @click="clearSearch" v-if="checkSearch()"></a>
                    </div>
                  </div>
                  <div class="uk-width-1-1">
                    Cliente:
                    <select v-model="client" class="uk-select">
                      <option value="">Todos</option>
                      <option
                        v-for="(client, index) in clients"
                        :value="client"
                        :key="index"
                      >
                        {{ client }}
                      </option>
                    </select>
                  </div>
                  <div class="uk-width-1-1">
                    <div>
                      Usuarios:
                      <select v-model="user" class="uk-select">
                        <option value="">Todos</option>
                        <option value="Mn75tSCem0N0hurzjeW3klvN3EE2">
                          Andres
                        </option>
                        <option value="6bOKOhjyKKOnkq1oVdeb96MB3843">
                          Dago
                        </option>
                        <option value="Puv5VI5ynnZEN76FKT8Vd9mEAoN2">
                          Edwin
                        </option>
                        <option value="ebfGmAWl0cQFdk9sYcSlq4bJYIX2">
                          Nela
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="uk-width-1-1">
                    Fecha de Inicio:
                    <input class="uk-input" type="date" v-model="startDate" />
                  </div>
                  <div class="uk-width-1-1">
                    Fecha de Fin:
                    <input class="uk-input" type="date" v-model="endDate" />
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
          <div class="uk-width-3-4">
            <div
              class="
                uk-card uk-card-default uk-card-body uk-border-rounded uk-margin
              "
            >
              <a @click="filterByPastMonth()" class="uk-button uk-button-default uk-border-rounded uk-margin-right">Mes Anterior</a>
              <a @click="filterByPastWeek()" class="uk-button uk-button-default uk-border-rounded">Semana Anterior</a>
              <div class="reports-chart" uk-grid>
                <div class="uk-width-1-1">
                  <div>
                    <table class="uk-table uk-table-striped uk-text-left">
                      <thead>
                        <tr>
                          <th>Tarea</th>
                          <th>Tiempo</th>
                          <th style="width:90px;">Fecha</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(log, index) in resultQuery" :key="index">
                          <td>
                            <h4 class="uk-margin-remove">{{ log.logDescription }}</h4>
                            <span
                              class="
                                uk-border-rounded
                                uk-label
                                uk-background-secondary
                                uk-text-xsmall
                              "
                            >
                              {{ log.client }}
                            </span> |
                            <span class="uk-border-rounded uk-label uk-background-primary uk-text-small">
                              {{ log.user }}
                            </span>
                          </td>
                          <td>{{ log.hours + "." + log.minutes }} hrs</td>
                          <td>{{ log.date }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDatabase,
  ref,
  onValue,
  query,
  orderByValue,
  orderByChild,
} from "firebase/database";
import Navigation from "@/components/Navigation.vue";
import TotalHours from "@/components/TotalHours.vue";

export default {
  name: "Reportes",
  components: {
    Navigation,
    TotalHours,
  },
  data() {
    return {
      searchQuery: null,
      logs: {},
      startDate: null,
      endDate: null,
      user: "",
      client: "",
    };
  },
  methods: {
    async getLogs() {
      const db = getDatabase();
      const logsRef = query(ref(db, "logs"), orderByValue("date"));

      onValue(logsRef, (snapshot) => {
        const data = snapshot.val();
        if (snapshot.exists()) {
          this.logs = data;
        } else {
          this.logs = {};
        }
      });
    },
    filterByPastMonth() {
      const today = new Date();
      const month = today.getMonth();

      const startDate = new Date(today.getFullYear(), month - 1, 1);
      const endDate = new Date(today.getFullYear(), month, 0);

      this.startDate = startDate.toISOString().split("T")[0];
      this.endDate = endDate.toISOString().split("T")[0];

    },
    filterByPastWeek() {
      const today = new Date();
      const week = today.getDay();

      const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
      const endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

      this.startDate = startDate.toISOString().split("T")[0];
      this.endDate = endDate.toISOString().split("T")[0];
    },
    checkSearch() {
      if (this.searchQuery) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch() {
      this.searchQuery = null;
    },
  },
  computed: {
    // sum of all hours
    totalHoursPlus() {
      let total = 0;
      for (let key in this.resultQuery) {
        total += this.resultQuery[key].hours;
      }
      return total;
    },
    // // sum of all minutes
    totalMinutesPlus() {
      let total = 0;
      for (let key in this.resultQuery) {
        total += this.resultQuery[key].minutes;
      }
      return total;
    },
    // // convert totalMinutesPlus to hours
    totalMinutesPlusConvertedToHours() {
      let total = this.totalMinutesPlus / 60;
      return total;
    },

    // // sum of all hours
    // totalHoursWorks() {
    //   return this.totalHoursPlus + this.totalHoursPlusConverted;
    // },

    totalHoursWorks() {
      // const minutes = this.resultQuery.reduce((acc, log) => {
      //   return acc + log.minutes * 0.60 / 60;
      // }, 0);

      // const hours = this.resultQuery.reduce((acc, log) => {
      //   return acc + log.hours;
      // }, 0);

      let hours = 0;
      for (let key in this.resultQuery) {
        hours += this.resultQuery[key].hours;
      }

      let minutes = 0;
      for (let key in this.resultQuery) {
        minutes += this.resultQuery[key].minutes;
      }

      let minutesToHours = minutes / 60;

      return hours + minutesToHours;
    },
    sortByDueDate() {
      return Object.values(this.logs).sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
    },
    resultQuery() {
      let filterType = this.searchQuery;

      const itemsByType = filterType
        ? this.sortByDueDate.filter((log) => log.logDescription.toLowerCase().indexOf(filterType.toLowerCase()) > -1 || log.client.toLowerCase().indexOf(filterType.toLowerCase()) > -1)
        : this.sortByDueDate;

      const itemsByUser = this.user
        ? itemsByType.filter((log) => log.uid === this.user)
        : itemsByType;

      const itemsByClient = this.client
        ? itemsByUser.filter((log) => log.client === this.client)
        : itemsByUser;

      return itemsByClient.filter((item) => {
        if (this.startDate && this.endDate) {
          return item.date >= this.startDate && item.date <= this.endDate;
        } else if (this.startDate) {
          return item.date >= this.startDate;
        } else if (this.endDate) {
          return item.date <= this.endDate;
        } else {
          return true;
        }
      });
    },
    clients() {
      const clients = [];

      Object.values(this.logs).forEach((log) => {

        const client = log.client;

        if (!clients.includes(client)) {
          clients.push(log.client);
        }
      });

      return clients.sort();
    },
  },
  created() {
    this.getLogs();
  },
};
</script>

<style></style>
